<template>
  <a-popover
    trigger="click"
    placement="bottom"
    overlay-class-name="align-card"
  >
    <template #title>
      <AlignUser
        :user="user"
        :avatar-size="40"
        :text-size="16"
        style="margin: 4px 0;"
      />
    </template>
    <template #content>
      <a-spin :spinning="isAligning">
        <a-space direction="vertical">
          <a-checkbox
            v-for="okrItem in myOkrItems"
            :key="okrItem.id"
            :checked="entity.alignedStatementIds.includes(okrItem.id)"
            @change="onCheckItem(okrItem.id, $event.target.checked, okrItem.realId)"
          >
            <a-space :style="{ alignItems: 'flex-start' }">
              <IconFont
                v-if="okrItem.type === 'objective'"
                type="iconmubiao"
                class="icon-block list-objective-icon"
              />
              <KeyResultIcon
                v-else
                class="list-kr-icon"
              />
              <div v-html="okrItem.content" />
            </a-space>
          </a-checkbox>
        </a-space>
      </a-spin>
    </template>
    <a-space
      class="clickable align-to-myself"
      @click.stop
    >
      <IconFont
        type="iconduiqi"
        class="icon-block"
      />
      {{ $t('okr.list.align') }}
    </a-space>
  </a-popover>
</template>

<script>
import { ref, computed, toRefs } from 'vue'
import { useStore } from 'vuex'
import { editObjectiveAuth, removeObjectiveAuth } from '@/api/auth'

import { align, unalign } from '@/api/okr'
import { getPublishedObjective, getPublishedKeyResult } from '@/graphql/okr'
import AlignUser from './AlignUser'
import KeyResultIcon from '@/components/KeyResultIcon'

export default {
  components: {
    AlignUser,
    KeyResultIcon
  },
  props: {
    entity: {
      type: Object,
      required: true
    },
    myOkrItems: {
      type: Array,
      required: true
    },
    alignedFromIdsChangeType: {
      type: String,
      required: true
    },
    userId: {
      type: Number,
      default: undefined
    }
  },
  emits: [
    'aligned'
  ],
  setup (props, { emit }) {
    const store = useStore()
    const user = computed(() => store.state.user)
    const isAligning = ref(false)

    const { alignedFromIdsChangeType } = toRefs(props)

    function getUpdatedEntity (id) {
      const fn = props.entity.type === 'objective' ? getPublishedObjective : getPublishedKeyResult
      return fn(id)
    }

    function onCheckItem (aligningId, checked, realId) {
      isAligning.value = true
      const fn = checked ? align : unalign
      fn(aligningId, props.entity.statementId)
        .then(() => getUpdatedEntity(props.entity.id))
        .then(updatedEntity => emit('aligned', updatedEntity))
        .finally(() => {
          isAligning.value = false
          if (alignedFromIdsChangeType.value === '-') {
            removeObjectiveAuth(realId, [props.userId], 2).then(res => {
              console.log(res)
            })
          } else if (alignedFromIdsChangeType.value === '+') {
            editObjectiveAuth(realId, [props.userId], 2).then(res => {
              console.log(res)
            })
          }
        })
    }

    return {
      isAligning,
      user,
      onCheckItem
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-checkbox-wrapper) {
  align-items: start;
}

:deep(.ant-checkbox) {
  margin: 3px 0;
}
</style>
